/**
 * The below file contains the fire detection state objects
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import { AUTH_TOKEN } from "redux/constants/Auth";
import {
  SET_ALL_FIRE_DETECTION,
} from "redux/constants/FireDetection";

//Initial state
const initState = {
  // Keys for dropdown 
  fireDetections: [],
  isFireDetectionDataFetched: false,
  // Keys for dropdown 
};

/**
 * The below function will update the state on the basis of action type.
 * @param {any} state State
 * @param {any} action Action
 * @returns Json object
 */
const fireDetection = (state = initState, action) => {
  switch (action.type) {
    //Cases for Fire detection dropdown
    case SET_ALL_FIRE_DETECTION:
      return {
        ...state,
        fireDetections: action.payload,
        isFireDetectionDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };
    //Cases for Fire detection dropdown

    default:
      return state;
  }
};

export default fireDetection;
